<template>
  <div id="map"></div>
</template>

<script>
export default {
  methods: {
    initMap() {
      var location = {lat:51.462146, lng: 5.63679};
      var mapLocation = {lat:51.472146, lng: 5.63679};

      // The map, centered at Uluru
      var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 15,
        center: mapLocation,
        disableDefaultUI: true,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        draggable: false
      });

      // The marker, positioned at Uluru
      var marker = new google.maps.Marker({ position: location, map: map });

      var infoWindow = new google.maps.InfoWindow();
      infoWindow.setOptions({
        content: `<div>${this.address.street} ${this.address.houseNumber}</div><div>${this.address.postalCode} ${this.address.city}</div>`,
        position: location
      });
      infoWindow.open(map, marker);
    }
  },
  computed: {
      address () {
          return this.$store.getters.contactInfo.address
      }
  },
  mounted() {
    this.initMap();
  }
};
</script>

<style lang="scss">
#map {
  width: 100%;
  height: 100%;
  background: lightgray;
}
</style>
